import 'reflect-metadata';

import { BaseEntity } from './base.entity';
import { Address } from './address.entity';
import { Profile } from './profile.entity';
import { AffinityMcq } from './affinity-mcq.entity';
import { Type } from 'class-transformer';
import { environment } from '../../../environments/environment';
import { AVATAR_PLACEHOLDER_URL } from '../../shared/shared.config';

export class User extends BaseEntity {
  email!: string;
  phoneNumber?: string;
  roles!: string[];
  imagePath?: string;
  isCoach!: boolean;
  isMarketingEmailsAccepted?: boolean;
  birthDate!: Date;
  @Type(() => Address)
  address?: Address;
  description?: string;
  @Type(() => Profile)
  profile?: Profile;
  @Type(() => AffinityMcq)
  affinityMcq?: AffinityMcq;

  // From IdentityTrait
  title?: string;
  firstName?: string;
  lastName?: string;

  // never returned from backend but used for sign up
  password?: string;

  // Used for sign up
  profileImage?: File;

  get imageUrl(): string {
    if (!this.imagePath) {
      return AVATAR_PLACEHOLDER_URL;
    }
    return `${environment.apiUrl}/upload/${this.imagePath}`;
  }
}
